'use client'

import { createContext, memo, use } from 'react'

export type ReactNativeContextType = {
  isInWebView: boolean | undefined
}

const ReactNativeContext = createContext<ReactNativeContextType | null>({
  isInWebView: undefined,
})

export const ReactNativeProvider = memo(function ReactNativeProvider({
  isInWebView,
  children,
}: React.PropsWithChildren<ReactNativeContextType>) {
  return (
    <ReactNativeContext.Provider value={{ isInWebView }}>{children}</ReactNativeContext.Provider>
  )
})

export function useIsReactNativeWebView() {
  const ctx = use(ReactNativeContext)

  if (!ctx) {
    return false
  }

  return ctx.isInWebView
}
